import { NavLink } from "react-router-dom";
import Drawer from "../drawer/Drawer";
import CustomButton from "../kits/custom-button/CustomButton";

export default function DrawerTxtBtn({
  isOpen,
  setIsOpen,
  height = 135,
  mainText,
  btnText,
  to = "noLink",
}) {
  return (
    <>
      <Drawer isOpen={isOpen} onClose={() => setIsOpen(false)} height={height}>
        <div className=" pd-x-20 mr-t-16 desc-c-l">{mainText}</div>
        {to == "noLink" ? (
          <div className="d-flex mr-x-20 mr-t-20 mr-b-16">
            <CustomButton
              className="pd-x-16 w-50 w-100"
              buttonStyle="primary"
              state="default"
              size="large"
              onClick={() => {
                setIsOpen(false);
              }}
            >
              <span className="title-h4-m">{btnText}</span>
            </CustomButton>
          </div>
        ) : (
          <NavLink
            to={`/${to}`}
            className="d-flex mr-x-20 mr-t-20 mr-b-16 text-decoration-none"
          >
            {" "}
            <CustomButton
              className="pd-x-16 w-50 w-100"
              buttonStyle="primary"
              state="default"
              size="large"
              onClick={() => {
                setIsOpen(false);
              }}
            >
              <span className="title-h4-m">{btnText}</span>
            </CustomButton>
          </NavLink>
        )}
      </Drawer>
    </>
  );
}
